import { render, staticRenderFns } from "./BoardReferenceWidget.vue?vue&type=template&id=e18a0dde&scoped=true&"
import script from "./BoardReferenceWidget.vue?vue&type=script&lang=js&"
export * from "./BoardReferenceWidget.vue?vue&type=script&lang=js&"
import style0 from "./BoardReferenceWidget.vue?vue&type=style&index=0&id=e18a0dde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18a0dde",
  null
  
)

export default component.exports